import { clearFilterParams, useCleanFilterForRequest, useFilterState } from '@btime/react-contexts'
import { gql } from '@apollo/client'
import { mergeDeepLeft } from 'ramda'
import { useIsMaster } from '@btime/react-session'
import React from 'react'

import { accountsClient } from '../../../../utils/apollo/api'
import { usePaginatedQuery } from '../../../../utils/apollo/_helpers/pagination'
import LazyAction from '../../../../packages/kiti/components/helpers/LazyAction'
import StatePresenter from '../../../../packages/kiti/components/helpers/StatePresenter'

const Context = React.createContext()
const { Provider } = Context
export const useUsersState = () => React.useContext(Context) || {}
export const useUsers = () => useUsersState()?.users || []

const QUERY = gql`
  query Users($page: Int, $search: String, $sort: UserSort, $filter: UserFilter) {
    users(page: $page, search: $search, sort: $sort, filter: $filter, limit: 12) {
      id
      name
      email
      contract {
        id
        insertedAt
        group {
          id
          name
        }
        groups {
          id
          name
        }
        profile {
          id
          name
          label
        }
      }
    }
  }
`

const UsersLoader = ({ children, columnFilters, uncontrolledChildren }) => {
  const { search, searchType } = useFilterState()
  const filter = mergeDeepLeft(clearFilterParams(columnFilters || []) || {}, useCleanFilterForRequest() || {})

  const { data, refetch, fetchMore, ...state } = usePaginatedQuery(QUERY, {
    variables: {
      page: 1, //
      search,
      searchType: !!searchType && !!search ? searchType : undefined,
      filter: { ...filter, hideMasters: !useIsMaster() }
    },
    flexiblePollInterval: 12000,
    client: accountsClient
  })

  return (
    <Provider value={data}>
      <StatePresenter {...state} uncontrolledChildren={uncontrolledChildren} empty={false}>
        {children}
      </StatePresenter>
      <LazyAction action={fetchMore} waiting={state.loading || state.isFetchingMore} />
    </Provider>
  )
}

UsersLoader.useList = useUsers

export default UsersLoader
